import React from 'react';

//Hooks
import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

//Components
import { NavLink } from 'react-router-dom';
import Icon from '../../components/Icon/Icon';

import { ROUTER_URL } from '../../const/ROUTER_URL';
import { ROUTER_PATH } from '../../const/ROUTER_PATH';

//Styles
import Styles from './Navigator.module.scss'

const Navigator = () => {
    const style = useSelector(state => state.widget.style);
    const tintColor = useSelector(state => state.companies.tintColor);

    const homeMatch = useRouteMatch({
        path: ROUTER_PATH.SHOPS,
    })
    const reservationsMatch = useRouteMatch({
        path: ROUTER_PATH.RESERVATIONS,
    });
    const signInReservationsMatch = useRouteMatch({
        path: ROUTER_PATH.SIGN_IN_RESERVATIONS,
    });
    const notificationsMatch = useRouteMatch({
        path: ROUTER_PATH.NOTIFICATIONS,
    });
    const profileMatch = useRouteMatch({
        path: ROUTER_PATH.PROFILE,
    });
    const signInProfileMatch = useRouteMatch({
        path: ROUTER_PATH.SIGN_IN_PROFILE,
    });


    const [isEditing, setEditing] = useState(false);

    const handleResize = useCallback(/* istanbul ignore next */ () => {
        if (window.innerWidth > 991) {
            return;
        }

        setEditing(!!document.activeElement && document.activeElement.tagName.toLowerCase() === 'input');
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return /* istanbul ignore next */ () => window.removeEventListener('resize', handleResize);
    });

    /* istanbul ignore next */
    if (isEditing) {
        return null;
    }

    return (
        <>
            {(style === 'dev' || style === 'website') && (
                <div className={Styles.websiteBox}/>
            )}
            <footer
                className={[
                    Styles.container,
                    style === 'inline' ? Styles.inline : '',
                    (style === 'dev' || style === 'website') ? Styles.website : ''
                ].join(' ')}
            >
                <div className={Styles.navigator}>
                    <NavLink
                        to={ROUTER_URL.SHOPS}
                        exact
                        className={Styles.button}
                        data-testid="data-test-footer-home"
                    >
                        <Icon
                            name="home"
                            size={28}
                            color={homeMatch ? tintColor : '#000'}
                        />
                    </NavLink>

                    <NavLink
                        to={ROUTER_URL.RESERVATIONS}
                        className={Styles.button}
                        data-testid="data-test-footer-reservations"
                    >
                        <Icon
                            name="calendar-event"
                            size={28}
                            color={(reservationsMatch || signInReservationsMatch) ? tintColor : '#000'}
                        />
                    </NavLink>

                    <NavLink
                        to={ROUTER_URL.NOTIFICATIONS}
                        className={Styles.button}
                        data-testid="data-test-footer-notifications"
                    >
                        <Icon
                            name={'bell'}
                            size={28}
                            color={notificationsMatch ? tintColor : '#000'}
                        />
                    </NavLink>

                    <NavLink
                        to={ROUTER_URL.PROFILE}
                        className={Styles.button}
                        data-testid="data-test-footer-profile"
                    >
                        <Icon
                            name="user"
                            size={28}
                            color={(profileMatch || signInProfileMatch) ? tintColor : '#000'}
                        />
                    </NavLink>
                </div>
            </footer>
        </>
    )
};


export default Navigator
